// UI helper utility functions

import ArrowsHorizontalWhite from '../assets/arrows-horizontal-white.png';
import ArrowsVerticalWhite from '../assets/arrows-vertical-white.png';
import AsteriskWhite from '../assets/asterisk-white.png';
import ArrowsHorizontal from '../assets/arrows-horizontal.png';
import ArrowsVertical from '../assets/arrows-vertical.png';
import Asterisk from '../assets/asterisk.png';

/**
 * Get unique material types from stock sheets
 * @param {Array} stockSheets - Array of stock sheet objects
 * @returns {Array} - Array of unique material type strings
 */
export const getMaterialTypes = (stockSheets) => {
  const materialTypes = stockSheets
    .map(sheet => sheet.materialType)
    .filter(material => material && material.trim() !== ''); // Remove empty values
  return [...new Set(materialTypes)]; // Return unique values
};

/**
 * Get grain direction icon based on grain direction value and theme mode
 * @param {string} grainDirection - The grain direction ('horizontal', 'vertical', or 'either')
 * @param {string} themeMode - The current theme mode ('dark' or 'light')
 * @returns {string} - Path to the icon image
 */
export const getGrainIcon = (grainDirection, themeMode = 'dark') => {
  const isDark = themeMode === 'dark';
  
  switch (grainDirection) {
    case 'horizontal':
      return isDark ? ArrowsHorizontalWhite : ArrowsHorizontal;
    case 'vertical':
      return isDark ? ArrowsVerticalWhite : ArrowsVertical;
    default:
      return isDark ? AsteriskWhite : Asterisk;
  }
};

